<template>
  <div class="dsfa-sc-panel">
    <div class="dsfa-sc-panel-header">
      <div class="dsfa-sc-panel-header__hd">
        <i
          v-if="icon"
          :class="['dsfa-sc-panel-header__hd-icon', 'icon', 'iconfont', icon]"
        >
        </i>
        <img
          class="dsfa-sc-panel-header__hd-icon-img"
          v-if="iconUrl"
          :src="iconUrl"
          alt=""
        />
        {{ title }}
        <span class="dsfa-sc-panel-header__hd-badge" v-if="badge && badge > 0">
          {{ badge }}
        </span>
      </div>
      <div class="dsfa-sc-panel-header__ft">
        <slot name="header"> </slot>
        <i v-if="search" class="dsfa-sc-panel-header__ft-icon el-icon-search"></i>
        <i
          v-if="more"
          class="dsfa-sc-panel-header__ft-icon el-icon-more-outline"
          @click="toUrl('more', moreConfig)"
        ></i>
        <i
          v-if="setting"
          class="dsfa-sc-panel-header__ft-icon el-icon-setting"
          @click="toUrl('setting', settingConfig)"
        ></i>
      </div>
    </div>
    <div class="dsfa-sc-panel-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfSCPanel",
  props: {
    title: {
      type: String,
      default: "这里是标题",
    },
    icon: {
      type: String,
      default: "",
    },
    iconUrl: {
      type: String,
      default: "",
    },
    search: {
      type: Boolean,
      default: false,
    },
    more: {
      type: Boolean,
      default: false,
    },
    moreConfig: {
      default() {
        return {};
      },
    },
    settingConfig: {
      default() {
        return {};
      },
    },
    setting: {
      type: Boolean,
      default: false,
    },
    // 标记
    badge: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {};
  },
  components: {},
  created() {},
  methods: {
    toUrl(type, config) {
      const { url, openType } = config;
      console.log(config);
      if (this.$listeners[`${type}Click`]) {
        this.$emit(`${type}Click`, config);
        return;
      }
      if (!url) return;
      this.$open({
        url,
        state: openType,
      });
    },
  },
};
</script>
